import { useEffect, useState } from "react";
import CategoryCard from "../components/CategoryCard";
import Breadcrumb from "../components/Breadcrumb";
import Loader from "../components/Loader";
import EmptyState from "../components/EmptyState";
import api from "../api/api";
import { getCached, setCached, isFresh } from "../utils/apiCache";
import "../styles/components/Categories.scss";

const BREADCRUMB_ITEMS = [{ label: "Home", to: "/" }, { label: "Categories" }];
const CACHE_KEY = "categories";

function toRoots(data) {
  return data.filter((category) => !category.parent_id);
}

function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    // Shares a cache key with Home.js - both fetch the same /categories
    // list, so visiting one warms the other too.
    const cached = getCached(CACHE_KEY);
    if (cached) {
      setCategories(toRoots(cached.data));
      setLoading(false);
    }

    const fetchCategories = async () => {
      try {
        const res = await api.get("/categories");
        const data = Array.isArray(res.data?.data) ? res.data.data : [];
        setCached(CACHE_KEY, data);
        if (active) setCategories(toRoots(data));
      } catch (err) {
        console.error(err);
        if (active && !cached) setError("Something went wrong.");
      } finally {
        if (active) setLoading(false);
      }
    };

    if (!isFresh(cached)) {
      fetchCategories();
    }

    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="categories-container reveal">
      <div className="page-head">
        <Breadcrumb items={BREADCRUMB_ITEMS} />
        <h1 className="page-title page-title--eyebrow page-title--lg">
          Categories
        </h1>
      </div>

      {loading ? (
        <Loader message="Loading categories..." />
      ) : error ? (
        <EmptyState message={error} variant="error" />
      ) : categories.length === 0 ? (
        <EmptyState message="No categories found" />
      ) : (
        <div className="categories-grid">
          {categories.map((category) => (
            <CategoryCard key={category.id} category={category} />
          ))}
        </div>
      )}
    </div>
  );
}

export default Categories;
